module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pp-mobile-footer__nav",
    on: {
      "touchdown": _vm.hideOverlays,
      "mousedown": _vm.hideOverlays
    }
  }, [_c('router-link', {
    staticClass: "pp-mobile-footer__nav__item",
    attrs: {
      "to": "/browse"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-mobile-phone"
  }), _vm._v(" "), _c('span', [_vm._v("Browse")])]), _vm._v(" "), _c('router-link', {
    staticClass: "pp-mobile-footer__nav__item",
    attrs: {
      "to": "/search"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-search"
  }), _vm._v(" "), _c('span', [_vm._v("Search")])]), _vm._v(" "), _c('router-link', {
    staticClass: "pp-mobile-footer__nav__item",
    attrs: {
      "to": "/queue"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-list-ul"
  }), _vm._v(" "), _c('span', [_vm._v("Queue")])]), _vm._v(" "), _c('router-link', {
    staticClass: "pp-mobile-footer__nav__item",
    attrs: {
      "to": "/account"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-user"
  }), _vm._v(" "), _c('span', [_vm._v("Account")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17a132cf","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileNav.vue
// module id = 172
// module chunks = 0